module.exports = __webpack_public_path__ + "static/media/plus_b.041d0a0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/carActiveMenu/img/plus_b.svg
// module id = 1659
// module chunks = 0